import { toggleReadyToShip } from '../helpers/updateURLParams';
import { clearFilterParams } from '../helpers/clearFilters';


type Props = {
  isTablet?: boolean
}


const ReadyToShipFilter = ({isTablet = false}: Props): JSX.Element => {
  const isToggled = window.location.search.includes('Ready+to+Ship')

  const handleToggleClick = () => {
    if (isToggled) {
      clearFilterParams()
      const urlChangeEvent = new CustomEvent('urlChange', { detail: {} })
      window.dispatchEvent(urlChangeEvent)
    } else {
      toggleReadyToShip()
      const urlChangeEvent = new CustomEvent('urlChange', { detail: {} })
      window.dispatchEvent(urlChangeEvent)
    }
  }

  return (
    <div className={`flex items-center gap-2.5 ${isTablet ? '' : 'absolute pr-5 right-0'}`}>
      <p className="font-calibre uppercase text-sm text-black">READY TO SHIP</p>
      <div onClick={handleToggleClick} className={`w-[26px] h-[13px] flex items-center rounded-full p-[.1rem] cursor-pointer ${isToggled ? 'bg-primary' : 'bg-neutral'}`}>
        <div className={`border-solid border border-black bg-white w-[11px] h-[11px] rounded-full shadow-md transform transition-transform duration-300 ease-in-out ${isToggled ? 'translate-x-3' : ''}`}/>
      </div>
    </div>
  )
}

export default ReadyToShipFilter